import ScalarIconLockSimpleOpen_vue_vue_type_script_setup_true_lang_default from "./ScalarIconLockSimpleOpen.vue.script.js";
//#region src/components/ScalarIconLockSimpleOpen.vue
var ScalarIconLockSimpleOpen_default = ScalarIconLockSimpleOpen_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconLockSimpleOpen_default as default };

//# sourceMappingURL=ScalarIconLockSimpleOpen.js.map